// import React from 'react';
import * as css from 'styles';
// import styled from 'react-emotion';
import styled from 'react-emotion';
import propStyles from 'prop-styles';

const View = styled('div')({
  display: 'block',
},
({ margin, padding, height, background, color, float, opacity }) => ({
  margin: margin || 'default',
  padding: padding || 'default',
  height: height || 'default',
  background: background || 'default',
  color: color || 'inherit',
  float: float || 'none',
  opacity: opacity || 1,
}),
propStyles({
  inline: {display: 'inline'},
  inlineBlock: {display: 'inline-block'},
  transition: {transition: css.transition.norm },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '2rem',
  },
  autogrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gridGap: '2rem',
  },
}))

export default View;



// WEBPACK FOOTER //
// ./src/components/View/View.js